import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/firebase';
import { AuthUser } from './user.types';

export interface UserState {
  readonly currentUser?: AuthUser | null;
  readonly isAuthInitialized: boolean;
  readonly error?: Error;
}

const INITIAL_STATE: UserState = {
  isAuthInitialized: false,
};

export const signOutUser = createAsyncThunk('user/signOut', async () => signOut(auth));

const userSlice = createSlice({
  name: 'user',
  initialState: INITIAL_STATE,
  reducers: {
    setCurrentUser(state, action: PayloadAction<AuthUser | null>) {
      state.currentUser = action.payload;
      state.isAuthInitialized = true;
    },
    /** Reflects a saved display name immediately, without re-fetching the Auth user. */
    setDisplayName(state, action: PayloadAction<string>) {
      if (state.currentUser) {
        state.currentUser.displayName = action.payload;
      }
    },
  },
});

export const { setCurrentUser, setDisplayName } = userSlice.actions;

export default userSlice;
